(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-collection-carousel')) {
    class ShopCollectionCarousel extends HTMLElement {
      constructor() {
        super();
        this.handleSlideClick = this.handleSlideClick.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handleInfiniteScroll = this.handleInfiniteScroll.bind(this);
        this.syncInfiniteLoop = this.syncInfiniteLoop.bind(this);
        this.pointerStartX = 0;
        this.loopEnabled = false;
        this.jumping = false;
        this.originalCount = 0;
      }

      connectedCallback() {
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderComponent = this.querySelector('slider-component');
        this.nextButton = this.querySelector('button[name="next"]');
        this.prevButton = this.querySelector('button[name="previous"]');
        if (!this.slider) return;
        this.slider.addEventListener('pointerdown', this.handlePointerDown);
        this.slider.addEventListener('click', this.handleSlideClick, true);
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.mediaQuery.addEventListener('change', this.syncInfiniteLoop);
        this.syncInfiniteLoop();
      }

      disconnectedCallback() {
        if (this.mediaQuery) {
          this.mediaQuery.removeEventListener('change', this.syncInfiniteLoop);
        }
        this.disableInfiniteLoop();
        if (!this.slider) return;
        this.slider.removeEventListener('pointerdown', this.handlePointerDown);
        this.slider.removeEventListener('click', this.handleSlideClick, true);
      }

      syncInfiniteLoop() {
        if (this.mediaQuery.matches) {
          this.enableInfiniteLoop();
        } else {
          this.disableInfiniteLoop();
        }
      }

      enableInfiniteLoop() {
        if (this.loopEnabled || !this.slider) return;

        const originals = Array.from(this.slider.querySelectorAll('.slider__slide:not(.sbc-carousel__slide--clone)'));
        if (originals.length < 2) return;

        this.originalCount = originals.length;
        const fragmentStart = document.createDocumentFragment();
        const fragmentEnd = document.createDocumentFragment();

        originals.forEach((slide) => {
          fragmentStart.appendChild(this.cloneSlide(slide));
          fragmentEnd.appendChild(this.cloneSlide(slide));
        });

        this.slider.insertBefore(fragmentStart, this.slider.firstChild);
        this.slider.appendChild(fragmentEnd);
        this.loopEnabled = true;
        this.slider.addEventListener('scroll', this.handleInfiniteScroll, { passive: true });

        if (this.sliderComponent && typeof this.sliderComponent.resetPages === 'function') {
          this.sliderComponent.resetPages();
        }

        this.jumpTo(this.getSetWidth());
        requestAnimationFrame(() => this.jumpTo(this.getSetWidth()));
      }

      disableInfiniteLoop() {
        if (!this.loopEnabled || !this.slider) return;

        this.slider.removeEventListener('scroll', this.handleInfiniteScroll);
        this.slider.querySelectorAll('.sbc-carousel__slide--clone').forEach((clone) => clone.remove());
        this.loopEnabled = false;
        this.originalCount = 0;

        if (this.sliderComponent && typeof this.sliderComponent.resetPages === 'function') {
          this.sliderComponent.resetPages();
        }

        this.jumpTo(0);
      }

      cloneSlide(slide) {
        const clone = slide.cloneNode(true);
        this.cloneUid = (this.cloneUid || 0) + 1;
        clone.id = `${slide.id || 'Slide'}-clone-${this.cloneUid}`;
        clone.classList.add('sbc-carousel__slide--clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('[id]').forEach((el) => {
          if (el !== clone) el.removeAttribute('id');
        });
        return clone;
      }

      getSetWidth() {
        if (!this.slider || this.originalCount < 1) return 0;
        const slides = Array.from(this.slider.querySelectorAll('.slider__slide'));
        const firstOriginal = slides[this.originalCount];
        const firstClone = slides[0];
        if (!firstOriginal || !firstClone) return 0;
        return firstOriginal.offsetLeft - firstClone.offsetLeft;
      }

      jumpTo(left) {
        if (!this.slider) return;
        this.jumping = true;
        this.slider.classList.add('sbc-carousel__list--jump');
        this.slider.scrollLeft = left;
        this.slider.classList.remove('sbc-carousel__list--jump');
        requestAnimationFrame(() => {
          this.jumping = false;
        });
      }

      handleInfiniteScroll() {
        if (this.jumping || !this.loopEnabled) return;

        const setWidth = this.getSetWidth();
        if (setWidth <= 0) return;

        if (this.slider.scrollLeft >= setWidth * 2 - 2) {
          this.jumpTo(this.slider.scrollLeft - setWidth);
        } else if (this.slider.scrollLeft <= 2) {
          this.jumpTo(this.slider.scrollLeft + setWidth);
        }
      }

      handlePointerDown(event) {
        this.pointerStartX = event.clientX;
      }

      handleSlideClick(event) {
        const slide = event.target.closest('.slider__slide');
        if (!slide || !this.slider.contains(slide)) return;

        if (Math.abs(event.clientX - this.pointerStartX) > 10) {
          event.preventDefault();
          return;
        }

        const sliderRect = this.slider.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const fullyVisible =
          slideRect.left >= sliderRect.left - 4 && slideRect.right <= sliderRect.right + 4;

        if (fullyVisible) return;

        event.preventDefault();
        event.stopPropagation();

        if (slideRect.right > sliderRect.right + 4 && this.nextButton) {
          this.nextButton.click();
        } else if (slideRect.left < sliderRect.left - 4 && this.prevButton) {
          this.prevButton.click();
        }
      }
    }

    customElements.define('shop-collection-carousel', ShopCollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
